import Cookie from "js-cookie";
import constants from "../values/constants";
import utils from ".";
interface iProps {
  token: string;
  userId: string;
  userType: string;
}
function setLoginData({ token, userType, userId }: iProps) {
  Cookie.set(constants.USER.IDENTIFY, userId, { expires: 7 });
  Cookie.set(constants.USER.TOKEN, token, { expires: 7 });
  Cookie.set(constants.USER.TYPE, utils.stringHexConversion.create(userType), {
    expires: 7,
  });
}
export default setLoginData;
